import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section id="cta-section" className="py-24 bg-white relative overflow-hidden" data-id="element-1">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-emerald-50/50 rounded-full blur-3xl -z-10" data-id="element-2"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl shadow-emerald-900/10 border border-emerald-100" data-id="element-4">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-5">
            Recupera tu ligereza y tu confianza hoy mismo
          </h2>
          <p className="text-xl text-stone-600 mb-8" data-id="element-6">
            por una fracción de lo que cuesta una consulta nutricional privada.
          </p>

          <div className="mb-10" data-id="element-7">
            <span className="block text-sm font-bold text-amber-500 uppercase tracking-wider mb-2" data-id="element-8">
              Precio Especial de Lanzamiento
            </span>
            <div className="text-5xl md:text-6xl font-extrabold text-emerald-600" data-id="element-9">
              $12.500{' '}
              <span className="text-2xl text-stone-400 font-medium" data-id="element-10">ARS</span>
            </div>
          </div>

          <Button size="lg" href="https://www.rutinavital.com/cart/47900606857460:1" className="w-full md:w-auto md:min-w-[320px] mb-6 text-lg py-5" data-id="element-11">
            QUIERO DESINFLAMARME AHORA
          </Button>

          <div className="flex items-center justify-center text-sm text-stone-500 mt-6" data-id="element-12">
            <ShieldCheck className="w-5 h-5 text-emerald-500 mr-2" data-id="element-13" />
            <span data-id="element-14">
              Pago seguro mediante Mercado Pago o Tarjeta de Crédito. Acceso
              instantáneo.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}